import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { calculateProblemTotal } from '../utils/calculations';

const SummaryCard = ({ problems, settings }) => {
  const totalCost = problems.reduce((sum, problem) => {
    return sum + calculateProblemTotal(problem, settings).cost;
  }, 0);

  return (
    <div className="bg-gray-900 text-white rounded-xl shadow-xl p-6 sticky top-6 transition-all duration-300">
      <h3 className="text-xl font-extrabold mb-6 flex items-center gap-2">
        <SafeIcon name="TrendingDown" className="text-red-500" />
        Gesamtauswertung
      </h3>

      <div>
        <p className="text-gray-400 text-sm font-semibold mb-1">
          Verlustkosten pro Jahr
        </p>
        <p className="text-3xl font-extrabold text-red-500">
          {totalCost.toLocaleString('de-DE', {
            style: 'currency',
            currency: 'EUR',
            maximumFractionDigits: 0
          })}
        </p>
      </div>

      <div className="mt-8 p-4 bg-gray-800 rounded-lg text-sm text-gray-300">
        <p className="flex items-start gap-2">
          <SafeIcon
            name="Info"
            className="mt-0.5 flex-shrink-0 text-blue-400"
          />
          <span>
            Diese Gesamtberechnung basiert auf {problems.length}{' '}
            {problems.length === 1 ? 'Position' : 'Positionen'}.
          </span>
        </p>
      </div>
    </div>
  );
};

export default SummaryCard;